var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "changeColor",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#31007A",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "changeColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0688 33.3871H15.9307C15.5334 33.3871 15.2101 33.0963 15.2101 32.7379V13.2621C15.2101 12.9038 15.5334 12.6129 15.9307 12.6129H21.702V18.0012C21.702 20.0423 23.2821 21.7016 25.2258 21.7016H30.7907V32.7379C30.7907 33.0963 30.4661 33.3871 30.0688 33.3871ZM30.335 19.1049H25.2258C24.7143 19.1049 24.2988 18.6102 24.2988 18.0012V12.6129H24.4442L30.335 19.1049ZM33.0499 18.2324L25.9815 10.442C25.7361 10.1707 25.3868 10.0162 25.0194 10.0162H15.9307C14.1012 10.0162 12.6133 11.473 12.6133 13.2621V32.7379C12.6133 34.5271 14.1012 35.9839 15.9307 35.9839H30.0688C31.8982 35.9839 33.3875 34.5271 33.3875 32.7379V19.1049C33.3875 18.7816 33.2667 18.4713 33.0499 18.2324Z",
    fill: "#8300DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.3c22d7b2cf83f605fbfc1a37c33ed9a6.svg";
export { ForwardRef as ReactComponent };